import React, { useState } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// Iconos
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';

// Components
import ItemsList from './itemsList';
import ChangePriceModal from './changePriceModal';
import ModalManualConfirm from '../../../../../components/modal/manualInvoice';

// Hooks
import useStyles from './styles';
import useCart from '../../../../../hooks/orders/CartProvider';
import useUser from '../../../../../hooks/user/useUser';

import { utils } from '../../../../../utils/utils';

const PurchaseItems = () => {
    const { classes } = useStyles();
    const { branch } = useUser();
    const { warehouses, sale: { currency, items, itemsToReturn, shippingData, originalOrderId }, update, existProcessedPayment } = useCart();
    const [itemToEditPrice, setItemToEditPrice] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmData, setConfirmData] = useState({
        message: "",
        onAccept: () => { },
        onClose: () => { }
    });

    const handleActionWithConfirm = (message, onAccept) => {
        setConfirmData({
            message,
            onAccept: () => {
                setShowConfirm(false);
                onAccept();
            },
            onClose: () => setShowConfirm(false),
        });

        setShowConfirm(true);
    };

    const handleDeleteItem = (key, items, itemSelected) => {
        const itemsToRemove = items
            .filter(i => i.refId !== itemSelected.refId || i.warehouseId !== itemSelected.warehouseId)

        update({ [key]: itemsToRemove });
    }

    const ConfirmDeleteItem = (key, items, itemSelected) => {
        if (key === 'itemsToReturn' && items.length === 1) {
            handleActionWithConfirm("Si quita todos los productos a devolver, esta orden ya no estara relacionada con la orden original", () => {
                handleDeleteItem(key, items, itemSelected)
            });
        } else {
            handleDeleteItem(key, items, itemSelected);
        }
    }

    const handleAddItem = (key, items, itemSelected) => {
        const itemsToAdd = items
            .map(item => {
                if (item.refId !== itemSelected.refId || item.warehouseId !== itemSelected.warehouseId)
                    return item;

                return {
                    ...item,
                    quantity: item.quantity + 1
                };
            });

        update({ [key]: itemsToAdd, shippingData: !(itemSelected.warehouseId !== branch.warehouseId) ? shippingData : null });
    }

    const handleRemoveItem = (key, items, itemSelected) => {
        const itemsToRemove = items
            .map(item => {
                if (item.refId !== itemSelected.refId || item.warehouseId !== itemSelected.warehouseId)
                    return item;

                return {
                    ...item,
                    quantity: item.quantity - 1
                };
            });

        update({ [key]: itemsToRemove });
    }

    const handleEditItem = (itemSelected, newUnitPrice) => {
        const newItems = itemsToReturn
            .map(item => {
                if (item.refId !== itemSelected.refId)
                    return item;

                return {
                    ...item,
                    unitPrice: newUnitPrice
                };
            });

        update({ itemsToReturn: newItems });
        setItemToEditPrice(null);
    }

    return (
        <>
            {
                itemToEditPrice &&
                <ChangePriceModal
                    currency={currency}
                    item={itemToEditPrice}
                    onClose={() => setItemToEditPrice(null)}
                    onChange={(item, price) => handleEditItem(item, price)}
                />
            }
            <ModalManualConfirm
                    open={showConfirm}
                    onAccept={confirmData.onAccept}
                    onCancel={confirmData.onClose}
                    onClose={confirmData.onClose}
                    message={confirmData.message}
            />
            <Paper className={classes.root}>
                {
                    items.length <= 0 && itemsToReturn.length <= 0 &&
                    <Grid container direction='column' alignItems='center' className={classes.noItems}>
                        <Grid>
                            <RemoveShoppingCartIcon />
                        </Grid>
                        <Grid>
                            <Typography variant='subtitle1'>
                                NO HAY PRODUCTOS EN LA ORDEN
                            </Typography>
                        </Grid>
                    </Grid>
                }
                { (items.length > 0 || itemsToReturn.length > 0) &&
                    <Grid container direction='column' spacing={1}>
                        <Grid size={12}>
                            <ItemsList
                                title="Productos"
                                items={items}
                                currency={currency}
                                warehouses={warehouses}
                                onAdd={(item) => handleAddItem('items', items, item)}
                                onDelete={(item) => handleDeleteItem('items', items, item)}
                                onRemove={(item) => handleRemoveItem('items', items, item)}
                                disabled={existProcessedPayment}
                            />
                        </Grid>
                        { itemsToReturn.length > 0 &&
                            <>
                                <Grid size={12}>
                                    <Divider fullWidth />
                                </Grid>
                                <Grid size={12}>
                                    <ItemsList
                                        title="Productos devueltos"
                                        items={itemsToReturn}
                                        currency={currency}
                                        warehouses={warehouses}
                                        onAdd={(item) => handleAddItem('itemsToReturn', itemsToReturn, item)}
                                        onDelete={(item) => ConfirmDeleteItem('itemsToReturn', itemsToReturn, item)}
                                        onRemove={(item) => handleRemoveItem('itemsToReturn', itemsToReturn, item)}
                                        onEditPrice={utils.validateStringNullOrEmpty(originalOrderId) 
                                            ? (item) => setItemToEditPrice(item)
                                            : null}
                                        disabled={existProcessedPayment}
                                    />
                                </Grid>
                            </>}
                    </Grid>}
            </Paper>
        </>
    );
}

export default PurchaseItems;